import { render, staticRenderFns } from "./FilterSingleChip.vue?vue&type=template&id=3a645310"
import script from "./FilterSingleChip.vue?vue&type=script&lang=js"
export * from "./FilterSingleChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports